import { observable, computed, makeObservable } from "mobx";

type HttpRequest = {
   id: number;
   url: string;
   waitMessage: string;
};

class RequestService {
   nextId: number = 1;
   activeRequests: HttpRequest[] = [];

   constructor() {
      makeObservable(this, {
         activeRequests: observable,
         isFetchingData: computed,
         waitMessage: computed,
      });
   }

   get isFetchingData(): boolean {
      return this.activeRequests.length > 0;
   }

   get waitMessage(): string {
      if (this.activeRequests.length) {
         return this.activeRequests[this.activeRequests.length - 1].waitMessage;
      }

      return "";
   }

   addRequest(url: string, waitMessage: string): number {
      if (!waitMessage) return 0;

      const req: HttpRequest = { url, waitMessage, id: this.nextId };

      this.nextId += 1;
      this.activeRequests.push(req);

      return req.id;
   }

   removeRequest(id: number) {
      if (id <= 0) return;

      let index = this.activeRequests.findIndex((r) => r.id === id);

      if (index >= 0) {
         this.activeRequests.splice(index, 1);
      }
   }
}

export default new RequestService();
